import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _this = this;

import * as tslib_1 from "tslib";
import { HistoryGetHistoryUrl } from '../constants';
import _ from 'lodash';
import dayjs from 'dayjs';

var get = function get(api) {
  return function (request) {
    return tslib_1.__awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var apiResponse, sanitizedHistoryItems;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return api.get(HistoryGetHistoryUrl, request);

            case 2:
              apiResponse = _context.sent;
              sanitizedHistoryItems = _.map(apiResponse.payload.Items, function (item) {
                var recordDate = dayjs(item.recordDate).toDate();
                var amount = Number(item.amount);
                var commission = Number(item.commission);
                var orderAction = String(item.orderAction);
                var fillPrice = Number(item.fillPrice);
                var description = String(item.description);
                var symbol = String(item.symbol);
                var fillQuantity = Number(item.fillQuantity);
                return Object.assign({}, item, {
                  description: description,
                  symbol: symbol,
                  orderAction: orderAction,
                  fillQuantity: fillQuantity,
                  fillPrice: fillPrice,
                  commission: commission,
                  amount: amount,
                  recordDate: recordDate
                });
              });
              return _context.abrupt("return", Object.assign({}, apiResponse, {
                Payload: apiResponse.payload ? Object.assign({}, apiResponse.payload, {
                  Items: sanitizedHistoryItems
                }) : undefined
              }));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};

export var history = {
  get: get
};